import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
// import ServicesBox from "../../Component/ServiceCMPT/ServicesBox";
// import { getServices } from "../../Utils/servicesApi";
import { Helmet } from "react-helmet";
import ServicesBox from "../../Component/ServiceCMPT/ServicesBox";
import { useAuth } from "../../Store/AuthContext";
import { ServiceFetchData } from "../../APIS/FetchAPIs";

export default function Services() {
  const { RendomTokenfetch, Pagemetatags } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);

  return (
    <>
      <Helmet>
        <title>{Pagemetatags.servicetitle}</title>
        <meta name="description" content={Pagemetatags.servicedescription} />
        <meta name="keywords" content={Pagemetatags.servicekeyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb pagename="Services" mainpage="" />
      <section
        className="featured section-padding bg_section"
        style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="row content">
            {ServiceData.length > 0
              ? ServiceData.map((service, index) => (
                  <ServicesBox key={index} SerData={service} />
                ))
              : ""}
          </div>
        </div>
      </section>
    </>
  );
}
